import React from 'react'
import Pagepath from './Pagepath'

function About() {
    return (
        <>
        <Pagepath path="About"/>
        <div className="about">
            <img src="https://thumbor.forbes.com/thumbor/960x0/https%3A%2F%2Fspecials-images.forbesimg.com%2Fdam%2Fimageserve%2F1138257321%2F960x0.jpg%3Ffit%3Dscale" alt="" />
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aspernatur quisquam dolorem suscipit dolores at saepe atque provident rem recusandae placeat adipisci ut quae mollitia non animi, quo aperiam consectetur. Nobis!
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque velit repellendus obcaecati placeat impedit. Magnam provident iure vitae non tenetur nam repellendus, architecto enim nesciunt cupiditate eligendi, repellat amet fugit!
            </p>
        </div>
        </>
    )
}

export default About
